import React from "react";
import {Card,ListGroup,ListGroupItem} from "react-bootstrap"
import '../styles/cardProducts.css'


const CardProduct =({product})=> {
  console.log(product)

  // const formatCurrency = (value) => {
  //   if (typeof value === "number") {
  //     return value.toLocaleString("es-CO", {
  //       style: "currency",
  //       currency: "COP",
  //       minimumFractionDigits: 0
  //     });
  //   }
  //   return "";
  // };
    return (
      <Card className="w3-margin cardContainer" >
        <Card.Img id="imgCard" variant="top" src={`https://full-rest-api.onrender.com/uploads/${product.image}`}  alt={product.name} />
        <Card.Body>
          <Card.Title>{product.name}</Card.Title>
          <Card.Text>
              {product.description}
          </Card.Text>
        <ListGroup className="list-group-flush">
          {/* <ListGroupItem>{formatCurrency(product.value)}</ListGroupItem> */}
          <ListGroupItem>{product.brand}</ListGroupItem>
          <ListGroupItem>{product.reference}</ListGroupItem>
        </ListGroup>
          <Card.Link href="#">Ver Detalle</Card.Link>
          <Card.Link href="#">Añadir a Cotizacion</Card.Link>
        </Card.Body>
      </Card>
    );
  }


export default CardProduct;
